<template>
  <div ref="containerRef" class="booking-wraper" id="detailBooking">
    <div class="main-body">
      <!-- <ul class="booking-tabs">
        <li v-for="tab in tabs" :key="tab.type" class="booking-tab" :class="{
          'is-active': modelBookingType === tab.type
        }" @click="setBookingType(tab.type)">
          {{ tab.title }}
          <template v-if="modelBookingType === tab.type">
            <span>已选航次：{{ currentVoyage.date | mapDateText }}</span>
          </template>
        </li>
      </ul> -->
	  <div class="text-dark font-medium text-base mb-3 px-5 pt-6">已选航次：{{ currentVoyage.date | mapDateText }}</div>
      <div class="j_relative_element">
        <div class="h-11">
          <VAffix class="z-10 bg-white" relative-element-selector=".j_relative_element" :offset="{ top: 0, bottom: 0 }" :scroll-affix="false"
            v-if=cabinClass.length>
            <div class="px-5" :style="affixStyles">
              <el-tabs class="cabin-tab numGt4" type="card" v-model="class_id">
                <el-tab-pane v-for="(row, rIndex) in cabinClass" :key="rIndex" :name="row.class_id">
                  <span slot="label">{{ row.class_name }}</span>
                </el-tab-pane>
              </el-tabs>
            </div>
          </VAffix>
        </div>

        <div class="booking-panels">
          <div :key="currentVoyage.id" class="booking-panel">
            <booking-bulk ref="refBookingBulk" v-model="priceData" v-if="modelBookingType === 'bulk'" :default-data="defaultBulkData"
              :productNo="productNo" :cruiseType="cruiseType" :class_id="class_id" :stockData="stockData" :bookingType="modelBookingType"
              :hasAlliance="currentVoyage.is_alliance == 1" :currentVoyage="currentVoyage" @onShowStock="handleShowStocks" />
            <booking-cut ref="refBookingCut" v-model="priceData" v-else :productNo="productNo" :default-data="defaultCutData" :stockData="stockData"
              :class_id="class_id" :bookingType="modelBookingType" :hasAlliance="currentVoyage.is_alliance == 1" :cruiseType="cruiseType"
              :currentVoyage="currentVoyage" @onShowStock="handleShowStocks" />
          </div>
        </div>
      </div>
      <!-- <v-loading :active="loading" :is-full-page="false"></v-loading> -->
    </div>
    <v-dialog name="modal-cabin-detail" :title="dialogTitle" height="auto" width="800">
      <DetailCabinStockTable :dialogTitle.sync="dialogTitle" :productNo="productNo" :spd-id="currentVoyage.id" />
    </v-dialog>
  </div>
</template>

<script>
import BookingBulk from "./DetailBookingBulk.vue";
import BookingCut from "./DetailBookingCut.vue";
import DetailCabinStockTable from "./DetailCabinStockTable";
import { isEmpty } from "@/utils/helpers";
import { useElementSize, useVModel } from "@vueuse/core";
import VAffix from "@/components/VAffix";
import { computed, defineComponent, ref } from "@nuxtjs/composition-api";
import ScrollActive from "@/components/ScrollActive";

// store
// import { mapState, mapMutations } from "vuex";

// api
// import {getBookingInfoByNo} from '@/services/order'

const tabs = [
	{ type: "bulk", title: "散卖" },
	{ type: "cut", title: "切舱" }
];

export default defineComponent({
	name: "Booking",
	components: {
		BookingBulk,
		BookingCut,
		DetailCabinStockTable,
		VAffix,
		ScrollActive
	},
	filters: {
		mapDateText(date) {
			if (!date) return "";
			let [, M, D] = date.split("-");
			return `${M}月${D}日`;
		}
	},
	props: {
		productNo: {
			type: String,
			default: "",
			required: true
		},
		cruiseType: {
			type: [Number, String],
			default: 1
		},
		stockData: {
			type: Array,
			default: () => []
		},
		currentVoyage: {
			type: Object,
			default: () => ({})
		},
		bookingType: {
			type: String,
			default: "bulk"
		},
		bookingData: {
			type: Object,
			default: () => ({})
		},
		cabinClass: {
			type: Array,
			default: () => []
		}
	},
	setup(props, { emit }) {
		const modelBookingType = useVModel(props, "bookingType", emit);
		const containerRef = ref();
		const {width} = useElementSize(containerRef);
		const affixStyles = computed(() => ({
			width: `${width.value}px`
		}));
		return {
			modelBookingType,
			containerRef,
			affixStyles
		};
	},
	data() {
		return {
			tabs,
			dialogTitle: "",
			priceData: {
				amount: "",
				profit: "",
				"people-num": "",
				"room-num": "",
				totalPriceTable: []
			},
			class_id: 0
			// bookingType: 'bulk'
			// bookingLoading: false,
			// defaultBookingType: 1,
			// defaultBookingData: {},
		};
	},
	watch: {
		priceData: {
			handler: function (value) {
				this.$emit("input", value);
			},
			deep: true
		},
		cabinClass: {
			immediate: true,
			handler: function (value) {
				if (isEmpty(value)) {
					return false;
				}
				console.log(value);
				let { class_id } = value[0];
				this.class_id = class_id;
			}
		}
	},
	computed: {
		// ...mapState("product/booking", {
		//   currentTab: "bookingType",
		//   loading: "stockLoading",
		//   bookingData: "bookingData",
		//   currentVoyage: "currentVoyage"
		// }),
		bookingNo() {
			let { booking_no } = this.$route.query;
			return booking_no;
		},
		defaultBulkData() {
			if (isEmpty(this.bookingData)) return [];
			let { sale_type, date } = this.bookingData.params;
			if (sale_type != 2 || date !== this.currentVoyage.date) return [];
			let { cabins = [] } = this.bookingData.results.change_cabins;
			return cabins;
		},
		defaultCutData() {
			if (isEmpty(this.bookingData)) return [];
			let { sale_type, date } = this.bookingData.params;
			if (sale_type != 1 || date !== this.currentVoyage.date) return [];
			let { cabins = [] } = this.bookingData.results.change_cabins;
			return cabins;
		}
	},
	async created() {
		// if(!this.bookingNo){
		//   return
		// }
		// this.bookingLoading = true;
		// let {code, data} = await getBookingInfoByNo({booking_no: this.bookingNo});
		// // this.bookingLoading = false;
		// if(code !== 10000){
		//   this.$notify({group: "msg", text: '获取预订信息失败'});
		//   return
		// }
		// let {params} = data;
		// this.defaultBookingData = data;
		// let defaultBookingType = params.sale_type == 1 ? 'cut' : 'bulk';
		// this.defaultBookingType = defaultBookingType;
		// this.setBookingType(defaultBookingType);
	},
	methods: {
		setBookingType(tab) {
			if (this.modelBookingType == tab) return;

			this.priceData = {
				amount: "",
				profit: "",
				"people-num": "",
				"room-num": "",
				totalPriceTable: []
			};
			this.modelBookingType = tab;
		},
		// ...mapMutations("product/booking", ["setBookingType"]),
		handleShowStocks() {
			this.$modal.show("modal-cabin-detail");
		},
		// 触发 提交 页面调用
		handleSubmit() {
			const ref = {
				bulk: "refBookingBulk",
				cut: "refBookingCut"
			}[this.modelBookingType];
			this.$refs[ref].handleSubmit();
		}
	}
});
</script>

<style lang="scss" scoped>

// @import "~@/assets/scss/base/public.scss";

.booking-wraper .main-body {
	padding: 0;
	position: relative;
}

.booking {
	&-tabs {
		display: flex;
		padding-top: 30px;
		padding-left: 20px;
	}

	&-tab {
		width: 220px;
		height: 32px;
		text-align: center;
		line-height: 32px;
		background: $color-grey-7;
		border-radius: 32px;
		margin-right: 10px;
		font-weight: 500;
		// transition: all $primary-transition;
		cursor: pointer;
		color: $secondary-text-color;
		user-select: none;

		&.is-active {
			background: $color-black-2;
			color: #fff;
		}
	}

	&-panel {
		padding: 10px 20px 0;
	}
}

::v-deep .cabin-tab {
	// margin: 20px 20px 0;

	.el-tabs__header {
		margin-bottom: 0;
	}

	.el-tabs__item {
		padding: 0 !important;
		text-align: center;
		border-bottom: 1px solid #ced4da;
	}
	.el-tabs__item:hover{
		color: $color-black-2;
	}

	.is-active {
		border-bottom: 3px solid $color-black-2 !important;
		color: $color-black-2;
	}
}

::v-deep.numGt4 {
	.el-tabs__item {
		width: 160px;
	}
}

::v-deep .numLgt4 {
	.el-tabs__item {
		width: 247px;
	}
}

</style>
